module.exports = __webpack_public_path__ + "media/images/countrysquared/as-7defa2892dcbecdf312a7994bde66652.svg";